import api from "../../api/axios";

const RD_DEBUG = false;

function dlog(...args) {
  if (RD_DEBUG) console.log("[RD][api]", ...args);
}

// GET /api/relatorio-diario?day=YYYY-MM-DD
// GET /api/relatorio-diario?start=YYYY-MM-DD&end=YYYY-MM-DD
export async function getRelatorioDiario({ day, start, end, gerencia, signal } = {}) {
  const params = {};
  if (day) params.day = day;
  if (start) params.start = start;
  if (end) params.end = end;
  if (gerencia) params.gerencia = gerencia;
  params._ = Date.now();

  dlog("GET", params);

  const res = await api.get("/relatorio-diario", {
    params,
    signal,
    headers: {
      "Cache-Control": "no-store",
      Pragma: "no-cache",
    },
  });

  return res.data; // { ok, start, end, count, rows }
}
